<template>
  <div class="container-chat padding-0">
    <div class="container-header">
      <chat-header @backToMenu="backToMenu" @newChat="newChat" />
    </div>
    <div class="container-history">
      <chat-history
        v-if="canChat"
        :history="history"
        :isSendMessage="isSendMessage"
        @onResendMedia="resendMedia"
        @onRemoveMediaDeliver="removeMediaDeliver"
      />
      <div v-else class="please-login">Cannot start chatting</div>
      <b-progress v-if="isLoading" :rounded="false" size="is-small" />
    </div>
    <div v-if="alert" class="container-alert">
      {{ alert }}
    </div>
    <div v-if="canChat" class="container-message">
      <chat-message @previewFile="previewFile" />
    </div>
  </div>
</template>

<script>
import apiChat from '@/api/chat'
import apiAccount from '@/api/account'

import ChatHeader from './components/header'
import ChatHistory from './components/history/index'
import ChatMessage from './components/message'

import { getToken } from '@/utils/auth'

import { v4 as uuidv4 } from 'uuid'
import Vue from 'vue'

export default {
  name: 'Chat',
  components: {
    ChatHeader,
    ChatHistory,
    ChatMessage
  },
  data() {
    return {
      canChat: true,
      history: [],
      isSendMessage: false,
      attachment: [],
      filesDeliverData: [],
      alert: null,
      previewMessage: false,
      userId: null,
      guestId: null,
      username: null,
      name: null,
      isLoading: false,
      uploadProgress: 0,
      historyLimit: 10,
      historySkip: 0,
      isMarkingAllAsRead: false,
      deviceToken: null
    }
  },
  async mounted() {
    try {
      await this.joinChat()
      this.monitorSocket()

      this.historySkip = 0
      this.getHistory()
    } catch (error) {
      console.error(error)
      this.canChat = false
    }
  },
  methods: {
    monitorSocket() {
      setInterval(async () => {
        if (!this.$socket.connected) {
          await this.joinChat()
        }
      }, 5000)
    },
    async joinChat() {
      const { PREFIX } = await apiChat.getConfig()

      // check user
      const userToken = getToken()
      if (userToken) {
        const { profile } = await apiAccount.getProfile()
        this.userId = profile._id
        this.$socket.emit('join', `${PREFIX}-${this.userId}`)
        this.username = profile.username
        this.name = profile.name
      } else {
        const guestId = localStorage.getItem('guest-id')
        if (guestId) {
          this.$socket.emit('join', `${PREFIX}-${guestId}`)
          this.guestId = guestId
        } else {
          const newGuestId = `guest-${uuidv4()}`
          localStorage.setItem('guest-id', newGuestId)
          this.$socket.emit('join', `${PREFIX}-${newGuestId}`)
          this.guestId = newGuestId
        }
      }
    },
    showAlert(message) {
      this.alert = message
      setTimeout(() => {
        this.alert = null
      }, 4000)
    },
    removeMediaDeliver({ deliverId }) {
      this.history = this.history.filter(
        h => !h.message.deliver || h.message.deliver.id != deliverId
      )
    },
    resendMedia({ deliverId }) {
      const fileDeliverData = this.filesDeliverData[deliverId]
      this.removeMediaDeliver({ deliverId })

      const reader = new FileReader()
      reader.readAsDataURL(fileDeliverData.file)
      reader.onload = () => {
        this.sendMedia({
          fileDeliverData
        })
      }
    },
    async backToMenu(text) {
      await this.sendMessage(text)
    },
    async newChat() {
      try {
        this.history = []
      } catch (error) {
        console.error(error)
      }
    },
    async getHistory(withRefresh = false) {
      try {
        if (this.isLoading) return
        if (withRefresh) {
          this.historySkip = 0
          this.historyLimit = 10
          this.history = []
        }

        this.isLoading = true
        const result = await apiChat.getHistory({
          userId: this.userId,
          guestId: this.guestId,
          limit: this.historyLimit,
          skip: this.historySkip
        })
        this.history = [...result.reverse(), ...this.history]

        if (this.history && this.history.length === 0) await this.newChat()
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    async getPreviousHistory() {
      const loadMore = 10
      this.historySkip += loadMore

      await this.getHistory()
    },
    async sendMessage(message) {
      try {
        const messagePackage = this.getMessagePackage({
          messageType: 'text',
          payload: this.getTextPayload(message)
        })
        const conversation = this.getConversationPackage({ messagePackage })

        this.isSendMessage = true

        const index = this.history.push(conversation) - 1
        setTimeout(async () => {
          const time = await apiChat.sendMessage(conversation)
          const updatedConversation = { ...this.history[index] }
          updatedConversation.createdAt = time
          Vue.set(this.history, index, updatedConversation)
        }, 500)
      } catch (error) {
        this.showAlert(error)
      }
    },

    async sendPostback(title, message) {
      try {
        console.log(title)
        console.log(message)
        // const messagePackage = this.getMessagePackage({
        //   messageType: 'postback',
        //   payload: this.getPostbackPayload(title, message)
        // })
        // const conversation = this.getConversationPackage({ messagePackage })

        // const index = this.history.push(conversation) - 1
        this.isSendMessage = true

        // setTimeout(async () => {
        //   const time = await apiWebhook.webhook(this.appId, conversation)
        //   this.history[index].createdAt = time
        // }, 500)
      } catch (error) {
        console.error(error)
      }
    },

    async sendMedia({ fileDeliverData }) {
      try {
        const onUploadProgress = event => {
          const progress = Math.round((100 * event.loaded) / event.total)
          this.uploadProgress = progress
          // this.history.forEach(e => {
          //   if (
          //     e.message.deliver &&
          //     e.message.deliver.id == fileDeliverData.deliverId
          //   ) {
          //     e.message.deliver.progress = progress
          //     return false
          //   }
          // })
        }

        this.isLoading = true
        let uploadResponse
        try {
          // this.setFileDeliverStatus(
          //   fileDeliverData.deliverId,
          //   Const.MessageDeliverStatus.SENDING
          // )
          if (fileDeliverData.fileType.includes('image')) {
            uploadResponse = await apiChat.uploadImage(
              fileDeliverData.file,
              onUploadProgress
            )
          } else if (fileDeliverData.fileType.includes('video')) {
            uploadResponse = await apiChat.uploadVideo(
              fileDeliverData.file,
              onUploadProgress
            )
          }
          // this.setFileDeliverStatus(
          //   fileDeliverData.deliverId,
          //   Const.MessageDeliverStatus.SUCCEED,
          //   true
          // )
        } catch (error) {
          console.error(error)
          // this.setFileDeliverStatus(
          //   fileDeliverData.deliverId,
          //   Const.MessageDeliverStatus.FAILED,
          //   true
          // )
        }

        this.filesDeliverData[fileDeliverData.deliverId] = fileDeliverData
        let messagePackage = this.getMessagePackage({
          messageType: 'media',
          payload: this.getMediaPayload({
            fileName: fileDeliverData.fileName,
            fileType: fileDeliverData.fileType,
            filePath: uploadResponse.path
          })
        })

        // messagePackage.deliver = {
        //   id: fileDeliverData.deliverId,
        //   status: Const.MessageDeliverStatus.SUCCEED,
        //   progress: 100
        // }

        const conversation = this.getConversationPackage({ messagePackage })

        this.isSendMessage = true
        const time = await apiChat.sendMessage(conversation)
        const index = this.history.push(conversation) - 1
        this.history[index].createdAt = time
      } catch (error) {
        this.showAlert(error)
      } finally {
        this.isLoading = false
      }
    },
    setFileDeliverStatus(deliverId, deliverStatus, resetProgress = false) {
      this.history.forEach(e => {
        if (e.message.deliver && e.message.deliver.id == deliverId) {
          if (resetProgress) {
            e.message.deliver.progress = 0
          }
          e.message.deliver.status = deliverStatus
          return false
        }
      })
    },
    getConversationPackage({ messagePackage }) {
      const conversation = {
        sender: 'customer',
        message: messagePackage,
        userId: this.userId,
        guestId: this.guestId,
        username: this.username,
        name: this.name,
        deviceToken: this.deviceToken
      }

      return conversation
    },

    getMessagePackage({ messageType, payload }) {
      return {
        message_type: messageType,
        payload: payload
      }
    },

    getMediaPayload({ fileName, fileType, filePath }) {
      const supportedImageType = [
        'image/jpg',
        'image/jpeg',
        'image/gif',
        'image/png'
      ]
      const supportedVideoType = ['video/mp4', 'video/quicktime']

      let payloadType = 'file'
      if (supportedImageType.includes(fileType)) {
        payloadType = 'image'
      } else if (supportedVideoType.includes(fileType)) {
        payloadType = 'video'
      }

      return {
        message: fileName,
        url: payloadType == 'image' || payloadType == 'video',
        fileType: payloadType,
        filePath: filePath
      }
    },

    getTextPayload(message) {
      return {
        message
      }
    },

    getPostbackPayload(title, message) {
      return {
        title,
        message
      }
    },

    async markAllAsRead() {
      if (!this.isMarkingAllAsRead) {
        this.isMarkingAllAsRead = true
        setTimeout(async () => {
          try {
            await apiChat.markAllAsRead({
              userId: this.userId,
              guestId: this.guestId
            })
          } catch (error) {
            console.error(error)
          } finally {
            this.isMarkingAllAsRead = false
          }
        }, 1000)
      }
    },

    async previewFile(data) {
      this.attachment = data
    },
    showPreviewMessage() {
      this.previewMessage = true
    },
    hiddenPreviewMessage() {
      this.previewMessage = false
    },
    resetSendMessage() {
      this.isSendMessage = false
    }
  },
  sockets: {
    messaging(data) {
      this.history.push(data)
      this.historySkip += 1
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  position: relative;
  bottom: 8px;
}
</style>
